<template>
  <div>
    <el-drawer :visible.sync="drawer" size="80%" @close="closeDrawer">
      <template slot="title">
        <div style="display: flex; align-items: center">
          <el-button
            style="
              width: 50px;
              margin-right: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            type="primary"
            @click="drawer = false"
            >关闭</el-button
          >
          <span>邀请分包商列表</span>
        </div>
      </template>
      <div
        v-loading="loading"
        style="
          padding: 0px 20px;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          flex-flow: column;
          padding-bottom: 20px;
        "
      >
        <!-- 操作按钮区域 -->
        <div style="margin-bottom: 20px">
          <el-button type="primary" size="mini" @click="openInviteDialog">
            <i class="el-icon-plus"></i> 邀请分包商填写
          </el-button>
          <el-button
            icon="el-icon-refresh
"
            type="primary"
            @click="getDataList"
            >刷新</el-button
          >
        </div>

        <!-- 表格区域 -->
        <el-table
          :data="tableData"
          stripe
          style="width: 100%; flex: 1"
          height="100%"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="cVenName"
            label="分包商名称"
            width="360"
            sortable
          />
          <el-table-column
            prop="cVenPerson"
            label="联系人"
            width="150"
            sortable
          />
          <el-table-column
            prop="cVenPhone"
            label="联系电话"
            width="150"
            sortable
          />
          <el-table-column
            prop="EquipmentClassificationName"
            label="设备分类"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="
                  !scope.row.EquipmentClassificationName ||
                  scope.row.EquipmentClassificationName.length <= 30
                "
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(
                      scope.row.EquipmentClassificationName
                    )"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.EquipmentClassificationName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="CreateTime"
            label="创建时间"
            width="150"
            sortable
          >
            <template slot-scope="scope">
              {{
                scope.row.CreateTime
                  ? moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-share"
                size="mini"
                @click="handleShowInviteCode(scope.row)"
              >
                邀请码
              </el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
                style="color: #f56c6c"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 空数据提示 -->
        <el-empty
          v-if="tableData.length === 0 && !loading"
          description="暂无数据"
          style="margin-top: 50px"
        ></el-empty>
      </div>
    </el-drawer>

    <!-- 邀请码弹窗 -->
    <el-dialog
      title="邀请码"
      :visible.sync="inviteCodeDialogVisible"
      width="800px"
      top="5vh"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div style="font-weight: bold; color: #000; font-size: 18px">
          点击红色链接复制
        </div>
      </div>
      <div style="font-weight: bold; font-size: 16px; margin-top: 20px">
        邀请码信息：
      </div>
      <div
        style="margin-top: 10px; color: red; cursor: pointer"
        @click="copyTEXT(tokenCode)"
      >
        {{ tokenCode }}
      </div>
      <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
        分包商填写资料地址：
      </div>
      <div
        style="margin-top: 10px; color: red; cursor: pointer"
        @click="copyTEXT(downloadUrl)"
      >
        {{ downloadUrl }}
      </div>
      <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
        <el-button type="warning" @click="copyValue">复制邀请链接</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="inviteCodeDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 邀请分包商弹窗 -->
    <el-dialog
      title="邀请分包商"
      :visible.sync="inviteDialogVisible"
      width="800px"
      top="5vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="inviteForm"
        :model="inviteForm"
        label-width="120px"
        label-position="right"
        :rules="inviteRules"
        v-loading="FormLoading"
        v-if="!isLink"
      >
        <el-form-item label="分包商手机号" prop="cVenPhone">
          <el-input
            v-model="inviteForm.cVenPhone"
            type="number"
            style="width: 60%"
            placeholder="请输入分包商手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备分类" required>
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            ref="tree"
            @check-change="handleCheckChange"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span
                v-if="data.children && data.children.length > 0"
                style="font-weight: 1000; font-size: 16px"
              >
                <i class="el-icon-s-grid" style="font-size: 18px"></i>&nbsp;{{
                  node.label
                }}</span
              >
              <span v-if="!data.children"
                ><i class="el-icon-receiving"></i> {{ node.label }}</span
              >
            </span>
          </el-tree>
        </el-form-item>
      </el-form>
      <div v-if="isLink">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="font-weight: bold; color: #000; font-size: 18px">
            点击红色链接复制
          </div>
        </div>
        <div style="font-weight: bold; font-size: 16px; margin-top: 20px">
          邀请码信息：
        </div>
        <div
          style="margin-top: 10px; color: red; cursor: pointer"
          @click="copyTEXT(tokenCode)"
        >
          {{ tokenCode }}
        </div>
        <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
          分包商填写资料地址：
        </div>
        <div
          style="margin-top: 10px; color: red; cursor: pointer"
          @click="copyTEXT(downloadUrl)"
        >
          {{ downloadUrl }}
        </div>
        <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
          <el-button type="warning" @click="copyValue">复制邀请链接</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="inviteDialogVisible = false" :loading="FormLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="subSupplierData"
          :loading="FormLoading"
          v-if="!isLink"
          >下 一 步</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import validate from '@/utils/validate/validate.js'

export default {
  name: 'TemplateInvitersList',
  data() {
    return {
      moment,
      drawer: false,
      loading: false,
      tableData: [],
      inviteCodeDialogVisible: false,
      currentRow: {},
      // 查询参数（可根据实际需求调整）
      queryParams: {},
      // 邀请分包商相关
      inviteDialogVisible: false,
      inviteForm: {
        cVenPhone: '',
      },
      FormLoading: false,
      inviteRules: {
        cVenPhone: [
          {
            validator: validate.validatePhone,
            trigger: 'blur',
            required: true,
            message: '请输入正确的手机号',
          },
        ],
      },
      isLink: false,
      EquipmentClassificationIds: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      tokenCode: '',
      downloadUrl: '',
      ProjectInfo: {},
      SupplierInfo: {},
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return '-'
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  methods: {
    formatTooltipContent(text) {
      if (!text) return []
      return text
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item)
    },
    /**
     * 打开抽屉
     * @param {Object} params - 查询参数
     */
    open(params = {}) {
      this.drawer = true
      this.queryParams = params
      console.log(params)
      this.tableData = []
      this.getDataList()
      this.tokenCode = window.localStorage.getItem('tokenCode')
    },

    /**
     * 关闭抽屉
     */
    closeDrawer() {
      this.drawer = false
      this.tableData = []
    },

    /**
     * 获取数据列表
     */
    getDataList() {
      this.loading = true

      this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetProjectSupplierTree?ProjectId=${
            this.queryParams.ProjectId || ''
          }&Type=${2}&SupId=${this.queryParams.SupplierId || ''}`,
          {}
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.tableData = res.Data || []
          } else {
            this.$notify.error(res.Msg || '获取数据失败')
          }
        })
        .catch((err) => {
          this.loading = false
          console.error('获取邀请人列表失败:', err)
          this.$notify.error('网络请求失败')
        })
    },

    /**
     * 显示邀请码
     */
    handleShowInviteCode() {
      this.inviteCodeDialogVisible = true
      this.downloadUrl =
        window.location.origin +
        '/TemplateLogin?ProjectId=' +
        this.ProjectInfo.Id
    },

    /**
     * 打开邀请分包商弹窗
     */
    openInviteDialog() {
      this.isLink = false
      this.inviteDialogVisible = true
      this.inviteForm.cVenPhone = ''
      this.EquipmentClassificationIds = []
      this.getTreeData()
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCheckedKeys([], false)
        }
        if (this.$refs.inviteForm) {
          this.$refs.inviteForm.resetFields()
        }
      })
    },

    /**
     * 提交邀请分包商数据
     */
    subSupplierData() {
      this.$refs.inviteForm.validate((valid) => {
        if (valid) {
          if (this.EquipmentClassificationIds.length == 0) {
            return this.$notify.error('请选择设备分类')
          }

          this.FormLoading = true
          this.$http
            .post(
              '/Base_ProjectWork/Base_ProjectSupplier/InvitationSubSupplierData',
              {
                ProjectId: this.ProjectInfo.Id,
                SupplierId: this.SupplierInfo.Id,
                DeviceTypes: [...this.EquipmentClassificationIds],
                cVenPhone: this.inviteForm.cVenPhone,
              }
            )
            .then((res) => {
              this.FormLoading = false
              if (res.Success) {
                this.isLink = true
                this.downloadUrl =
                  window.location.origin +
                  '/TemplateLogin?ProjectId=' +
                  this.ProjectInfo.Id
                this.$notify.success('生成分包商链接成功')
                this.getDataList()
              } else {
                this.$notify.error(res.Msg)
              }
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    /**
     * 树形选择变化
     */
    handleCheckChange() {
      this.EquipmentClassificationIds = this.$refs.tree.getCheckedKeys()
    },

    /**
     * 获取树形数据
     */
    getTreeData() {
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetTemplateData', {
          ProjectId: this.ProjectInfo.Id,
          SupplierId: this.SupplierInfo.Id,
        })
        .then((res) => {
          if (res.Success) {
            this.treeData = res.Data?.Data[0]?.children || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },

    /**
     * 复制文本
     */
    copyTEXT(text) {
      const t = document.createElement('textarea')
      t.nodeValue = text
      t.value = text
      document.body.appendChild(t)
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.$notify.success('复制成功')
    },

    /**
     * 复制完整邀请信息
     */
    copyValue() {
      let text = `填写资料链接地址：${this.downloadUrl}   邀请码信息：${this.tokenCode}  请复制链接后在浏览器中打开，即可填写资料`
      const t = document.createElement('textarea')
      t.nodeValue = text
      t.value = text
      document.body.appendChild(t)
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.$notify.success('复制成功')
    },

    /**
     * 删除分包商
     */
    handleDelete(row) {
      this.$confirm(`确定要删除该分包商吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_ProjectWork/Base_ProjectSupplier/DeleteData', [row.Id])
            .then((res) => {
              this.loading = false
              if (res.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(res.Msg || '删除失败')
              }
            })
            .catch((err) => {
              this.loading = false
              console.error('删除失败:', err)
              this.$notify.error('网络请求失败')
            })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin-bottom: 20px;
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}

::v-deep .el-drawer__body {
  padding: 0;
  overflow: hidden;
}
::v-deep .el-tree {
  height: 60vh;
  overflow-y: auto;
}

/* 自定义 tooltip 内容样式 - 三列布局 */
.custom-tooltip-content {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 8px 16px;
  max-width: 600px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 4px;
  line-height: 1.8;
}

.tooltip-item {
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  line-height: 1.8;
  word-break: break-word;
  padding: 2px 4px;
  color: #fff;
}

.tooltip-icon-square {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #67c23a;
  margin-right: 8px;
  margin-top: 6px;
  flex-shrink: 0;
}

.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  cursor: default;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  i {
    margin-right: 6px;
  }
}
</style>
